export default {
    namespaced: true,
    state: {
        isSignUpSuccess: false,  // 用于跟踪报名状态 
        isFouse: false
    },
    
    mutations: {  
        setSignUpSuccess(state, status) {  
          state.isSignUpSuccess = status;  
        },  
        setFouse(state, status) {
          state.isFouse = status;
        }
      },  
    actions: {},
  };
  